import { applicationFeeEscalationsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const LOAN_FEE_ESCALATIONS_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/feeEscalations`,
  {
    GET_FEE_ESCALATIONS: 'GET_FEE_ESCALATIONS',
  },
);

export const getLoanFeeEscalationsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationFeeEscalationsApi.getFeeEscalations(params);

  return dispatch({
    type: LOAN_FEE_ESCALATIONS_ACTION_TYPE.GET_FEE_ESCALATIONS,
    payload: data,
  });
});
